import { Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

export default function CallInfo({ startDate, startTime, endTime, clientName }) {
  return (
    <div>
      <Typography className="text-[16px] font-semibold" style={{ color: HNSColors.neutrals[100] }}>
        {`Date: ${startDate} — Time: ${startTime}${endTime ? " - " + endTime : ""}`}
      </Typography>
      <Typography className="text-[14px]" style={{ color: HNSColors.neutrals[300] }}>
        <span className="font-semibold">Client: </span>
        {clientName}
      </Typography>
    </div>
  );
}
